import { useState, useCallback, useMemo } from "react";
import { MessageItem } from "models/inbox/inbox";
import { useGlobalContext } from "app/store/GlobalContext";
import MessageSidebarItem from "views/inbox/components/Inbox/sidebar/messageSidebarItem";
import NoMessagesToShowInfoText from "./noMessagesToShowInfoText/noMessagesToShowInfoText";

import "../index.scss";

type Props = {
  messages: MessageItem[];
};

export default function MessageSidebarList({ messages }: Props) {
  const { handleNavigation } = useGlobalContext();
  const [activeMessageId, setActiveMessageId] = useState<string>("");

  const sortMessages = useMemo(() => {
    return [...(messages ?? [])].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }, [messages]);

  const handleOnSelect = useCallback(
    (messageId: string, e) => {
      setActiveMessageId(messageId);
      handleNavigation({
        url: `/inbox/sent/${messageId}`,
        eventTitle: "Message",
        e: e
      });
    },
    [handleNavigation]
  );

  if (!messages?.length) {
    return <NoMessagesToShowInfoText />;
  }

  return (
    <>
      {sortMessages.map((msg) => {
        const { messageId } = msg;
        return (
          <MessageSidebarItem
            key={messageId}
            message={msg}
            isActive={activeMessageId === messageId}
            onSelect={(e) => handleOnSelect(messageId, e)}
          />
        );
      })}
    </>
  );
}
